export default (input, idx1, idx2) => {
    const temp = input[idx1];
    input[idx1] = input[idx2];
    input[idx2] = temp;
};
